import React from "react";
import { connect } from "react-redux";
import { selectIsItemRemovalProcessing, selectIsRoomDesignProcessing, selectIsImageEditingProcessing } from "../selectors";

interface TabNavBarProps {
  activeTab: string;
  onTabChange: (tabName: string) => void;
  isItemRemovalProcessing: boolean;
  isRoomDesignProcessing: boolean;
  isImageEditingProcessing: boolean;
}

const TabNavBar: React.FC<TabNavBarProps> = ({
  activeTab,
  onTabChange,
  isItemRemovalProcessing,
  isRoomDesignProcessing,
  isImageEditingProcessing
}) => {
  return (
    <div className="max-w-8xl w-full mx-auto py-3 px-4 sm:px-6 md:px-8">
      <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200">
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "roomDesign"
                ? "text-white bg-orange-500 shadow-md"
                : "text-gray-700 bg-gray-100 hover:bg-gray-200"
            } ${isItemRemovalProcessing || isImageEditingProcessing ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isItemRemovalProcessing && !isImageEditingProcessing && onTabChange("roomDesign")}
            disabled={isItemRemovalProcessing || isImageEditingProcessing}
          >
            AIホームステージング
          </button>
        </li>
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "itemRemoval"
                ? "text-white bg-orange-500 active"
                : "bg-gray-100 text-gray-600 hover:text-gray-700 hover:bg-gray-200"
            } ${isRoomDesignProcessing || isImageEditingProcessing ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isRoomDesignProcessing && !isImageEditingProcessing && onTabChange("itemRemoval")}
            disabled={isRoomDesignProcessing || isImageEditingProcessing}
          >
            AI家具消し
          </button>
        </li>
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "imageEditing"
                ? "text-white bg-orange-500 active"
                : "bg-gray-100 text-gray-600 hover:text-gray-700 hover:bg-gray-200"
            } ${isRoomDesignProcessing || isItemRemovalProcessing ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isRoomDesignProcessing && !isItemRemovalProcessing && onTabChange("imageEditing")}
            disabled={isRoomDesignProcessing || isItemRemovalProcessing}
          >
            画像編集
          </button>
        </li>
      </ul>
    </div>
  );
};

interface RootState {
  itemRemoval: {
    isLoading: boolean;
    selectedRegenImage: string | null;
    [key: string]: unknown;
  };
  roomDesign: {
    isLoading: boolean;
    selectedRegenImage: string | null;
    [key: string]: unknown;
  };
  imageEditing: {
    isProcessing: boolean;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

const mapStateToProps = (state: RootState) => ({
  isItemRemovalProcessing: selectIsItemRemovalProcessing(state),
  isRoomDesignProcessing: selectIsRoomDesignProcessing(state),
  isImageEditingProcessing: selectIsImageEditingProcessing(state)
});

export default connect(mapStateToProps)(TabNavBar);